import { gql } from 'src/__generated__';

export const ADD_LICENCE = gql(`
  mutation ApplyAddLicence(
    $input: UpdateLicenceInput!
    $languageCode: LanguageCodeIso
    $zone: Zone
  ) {
    updateLicence(input: $input) {
      viewer {
        _id
        licences(languageCode: $languageCode, zone: $zone) {
          ...licence
        }
      }
    }
  }
`);
